import React, { Component } from 'react';
import './OnBoardingPage.css';

// Phase 2: Navigation Integration handled by OnBoardingPageWrapper.tsx

// Phase 3: i18n Integration - UNCOMMENTED
import { withTranslation } from 'react-i18next';

// Phase 7: Redux Integration - UNCOMMENTED
import { connect } from 'react-redux';

// Phase 5: SVG Icons Integration - UNCOMMENTED (matching TutorialPage pattern)
import { ReactComponent as GoalsFocus130Icon } from '../../../assets/icons/tab-bar/goals-focus-130.svg';
import { ReactComponent as AnnouncementFocus130Icon } from '../../../assets/icons/tab-bar/announcement-focus-130.svg';
import { ReactComponent as CalendarFocus130Icon } from '../../../assets/icons/tab-bar/calendar-focus-130.svg';

// Phase 4: Carousel Library - UNCOMMENTED (matching TutorialPage pattern)
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel as CarouselComponent } from 'react-responsive-carousel';

interface OnBoardingPageState {
  // Phase 1: State matching reference project
  backButtonCount: number;
}

interface OnBoardingPageProps {
  // Phase 3: i18n Props - UNCOMMENTED
  t: (key: string) => string;
  // Phase 2: Navigation Props - UNCOMMENTED (optional like TutorialPage)
  navigate?: (path: string) => void;
}

class OnBoardingPage extends Component<OnBoardingPageProps, OnBoardingPageState> {
  constructor(props: OnBoardingPageProps) {
    super(props);
    this.state = {
      // Phase 1: State matching reference project
      backButtonCount: 0
    };
  }

  // Phase 1: Component Lifecycle - matching reference project
  componentDidMount() {
    // Handle back button logic for web (simplified from Android logic)
    // window.addEventListener('beforeunload', this.handleBeforeUnload);
  }

  componentWillUnmount() {
    // window.removeEventListener('beforeunload', this.handleBeforeUnload);
  }

  // Phase 2: Navigation Methods - UNCOMMENTED
  _back = () => {
    const { navigate } = this.props;
    if (navigate) {
      // Navigate back to settings page (reference project behavior)
      navigate('/settings');
    }
  }

  // Phase 2: Back Button Logic - simplified from reference project
  // handleBeforeUnload = (event: BeforeUnloadEvent) => {
  //   // Web equivalent of Android back button logic
  //   event.preventDefault();
  //   event.returnValue = 'Press again to exit';
  // }

  render() {
    // Phase 1: State Destructuring - matching reference project
    const { backButtonCount } = this.state;
    // Phase 3: i18n Destructuring - UNCOMMENTED
    const { t } = this.props;

    // Phase 4 & 5: Carousel Data with SVG Icons - UNCOMMENTED (matching TutorialPage)
    const slides = [
      {
        icon: <GoalsFocus130Icon className="slide-svg" />,
        title: t("tutorial-screen:title.goals"),
        content: t("tutorial-screen:content.goals"),
        className: "slide-goals"
      },
      {
        icon: <AnnouncementFocus130Icon className="slide-svg" />,
        title: t("tutorial-screen:title.announcements"),
        content: t("tutorial-screen:content.announcements"),
        className: "slide-announcements"
      },
      {
        icon: <CalendarFocus130Icon className="slide-svg" />,
        title: t("tutorial-screen:title.calendar"),
        content: t("tutorial-screen:content.calendar"),
        className: "slide-calendar"
      }
    ];

    return (
      <div className="onboarding-page">
        {/* Phase 1: Container Structure - matching reference project */}
        <div className="onboarding-container">
          {/* Phase 2: Back Button - matching reference project */}
          <div className="onboarding-back">
            <div className="onboarding-back-inner">
              <button 
                className="back-button"
                onClick={this._back}
              >
                <svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.79646 0.204319C6.07989 0.482194 6.07989 0.943465 5.80201 1.2269L2.42862 4.61141H15.2831C15.6777 4.61141 16 4.93374 16 5.33388C16 5.73402 15.6777 6.05635 15.2831 6.05635H2.42862L5.80757 9.44086C6.08545 9.72429 6.07989 10.18 5.80201 10.4634C5.51858 10.7413 5.06843 10.7413 4.78499 10.4579L0.205627 5.84517C0.144495 5.77848 0.0944773 5.70623 0.0555749 5.61731C0.0166725 5.52839 0 5.43391 0 5.33944C0 5.15048 0.0722476 4.97264 0.205627 4.8337L4.78499 0.220992C5.05731 -0.0679974 5.51303 -0.073555 5.79646 0.204319Z" fill="black"></path></svg>
              </button>
            </div>
          </div>
          

          {/* Phase 1: Header Section - matching reference project and TutorialPage */}
          <div className="onboarding-header">
            <div className="logos-container">
              <img 
                src={require('../../../assets/icons/cdc-logo.png')} 
                alt="CDC Logo" 
                className="logo-cdc"
              />
              <img 
                src={require('../../../assets/icons/fwd-logo.png')} 
                alt="FWD Logo" 
                className="logo-fwd"
              />
            </div>
          </div>

          {/* Phase 1 & 4: Body Section - Carousel matching TutorialPage */}
          <div className="onboarding-body">
            <div className="carousel-container">
              {/* Phase 4: Carousel Implementation - UNCOMMENTED (matching TutorialPage) */}
              <CarouselComponent
                showArrows={false}
                showStatus={false}
                showThumbs={false}
                infiniteLoop={false}
                autoPlay={false}
                // Smooth animation: 350ms is a good default for human-perceived smoothness
                transitionTime={350}

                // Swipe behavior
                swipeable={true}                         // enable swiping
                emulateTouch={true}                      // allow mouse to drag like touch on desktop. Good for trackpads.
                preventMovementUntilSwipeScrollTolerance={true} // avoid accidental drags while scrolling vertically
                swipeScrollTolerance={30}                // how many pixels required to trigger a horizontal swipe

                // Accessibility & UX
                useKeyboardArrows={true}                 // left/right with keyboard
                stopOnHover={true}                       // if you later enable autoplay, this is useful
              >
                {slides.map((slide, index) => (
                  <div key={index} className={`carousel-slide ${slide.className}`}>
                    <div className="slide-icon">
                      {/* Phase 5: SVG Icons - UNCOMMENTED */}
                      {slide.icon}
                    </div>
                    <h2 className="slide-title">
                      {/* Phase 3: i18n Integration - UNCOMMENTED */}
                      {slide.title}
                    </h2>
                    <p className="slide-content">
                      {/* Phase 3: i18n Integration - UNCOMMENTED */}
                      {slide.content}
                    </p>
                  </div>
                ))}
              </CarouselComponent>
            </div>
          </div>

          {/* Note: No footer buttons - key difference from TutorialPage */}
          {/* OnBoardingPage focuses only on tutorial content with back navigation */}
        </div>
      </div>
    );
  }
}

// Navigation handled by OnBoardingPageWrapper.tsx (matching TutorialPage pattern)

// Phase 7: Redux connection - UNCOMMENTED (matching reference project)
const mapStateToProps = (state: any) => {
  return {
    // Empty mappers matching reference project simplicity
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    // Empty mappers matching reference project simplicity
  }
}

// Phase 3 & 7: Export with Redux + i18n - UNCOMMENTED (matching TutorialPage pattern)
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(OnBoardingPage));
